import React from 'react'
import { Box, Grid } from '@mui/material'
import { useIsLg } from '../../../theme/useIsLg'

function LogosBar({
  logos,
  columns = { xs: 4, sm: 4, md: 2, lg: 2 },
  minWidth,
}) {
  const isLg = useIsLg()
  return (
    <Box
      sx={{
        bgcolor: 'mono.white',
        p: {
          xs: '28px 40px',
          sm: '28px 40px',
          md: '48px 0px',
          lg: '48px 0px',
        },
        m: 0,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderBottom: '1px solid rgba(31, 36, 45, 0.1)',
      }}
    >
      {logos.map(({ id, logo }, index) => (
        <Box
          key={id}
          sx={{
            display: 'flex',
            flex: 1,
            minWidth,
            alignItems: 'center',
            justifyContent: 'center',
            pb: index <= 1 ? '16px' : '0px',
          }}
          style={{
            paddingTop: isLg ? '0px' : '12px',
            paddingBottom: isLg ? '0px' : '12px',
          }}
        >
          {logo}
        </Box>
      ))}
    </Box>
  )
}

export default LogosBar
